import React, { useRef, useState } from "react";
import { Form, Overlay, Tooltip } from "react-bootstrap";
import infobtn from "../../assets/images/infobtnblue.svg";
import InputDetail from "./InputDetail";
import { ENUMS } from "../../services/Enums";
const File = ({ compObj, handleChange, isDisable, showtype, labelAction, nodeContext }) => {
    const [file, setFile] = useState(compObj?.value ? compObj?.value : null);
    const MachineLogoref = useRef();
    const [showInputDetailPopup, setShowInputDetailPopu] = useState(false);
    const targetInputDetail = useRef();
    const fileRef = useRef(null);

    const handleOverlay = (e) => {
        let element = document.getElementById(e?.currentTarget?.id);
        if (element) {
            if (element.classList.contains("overlay-isopen")) {
                element.classList.remove("overlay-isopen");
            } else {
                element.classList.add("overlay-isopen");
            }
        }
    };

    const handleShowInputDetailPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setShowInputDetailPopu(!showInputDetailPopup);
    };

    const clearFile = () => {
        if (fileRef.current) {
            fileRef.current.value = "";

        }
        handleChange("", compObj)
    };

    return (
        <>
            <div className="config-input-label-container">
                <Form.Label className="common-label text-capitalize">
                    {compObj?.parakey.replaceAll("_", " ")}
                    {showtype && <> ({compObj?.paratype})</>}
                </Form.Label>
                {compObj?.details && (
                    <span
                        className="config-info-btn cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            handleOverlay(e);
                            setShowInputDetailPopu(!showInputDetailPopup);
                            handleShowInputDetailPopup();
                        }}
                        ref={targetInputDetail}
                    >
                        <img src={infobtn} alt="infobtn" />
                    </span>
                )}
                {
                    !ENUMS.workflowparamsnotbindonthiskey.includes(compObj?.parakey.toUpperCase()) &&
                    labelAction
                }
            </div>

            <div className={`file-input custom-file-upload input-group mb-2`}>
                <label onClick={() => fileRef.current.click()}>Browse</label>
                <input
                    className="common-input form-control"
                    type="text"
                    value={compObj?.filename ? compObj?.filename : "Choose file"}
                    readOnly
                    onClick={() => fileRef.current.click()}
                />
                <label onClick={() => clearFile()}>X</label>
                <input
                    ref={fileRef}
                    hidden
                    type="file"
                    className="form-control"
                    id="profileImg"
                    title={compObj?.filename ? compObj?.filename : ""}
                    onChange={(e) => {
                        if (handleChange) {
                            handleChange(e.target.files[0], compObj);
                        }
                    }}
                    disabled={isDisable ? isDisable : false}
                />


            </div>
            {showInputDetailPopup && (
                <Overlay
                    target={targetInputDetail.current}
                    show={handleShowInputDetailPopup}
                    placement="bottom"
                    flip
                >
                    <Tooltip id="overlay-example">
                        <InputDetail
                            handleshowPopup={handleShowInputDetailPopup}
                            compObj={compObj}
                        />
                    </Tooltip>
                </Overlay>
            )}
        </>
    );
};

export default File;
